import React, { Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import ServiceNav from '../../components/ServiceNav';
import ServicePortfolio from '../../components/ServicePortfolio';
import icon from '../../images/icon/magic.svg';
import Seo from '../../components/Seo';

const ServiceSidebar = ({ lang }) => {
    const { t } = useTranslation();
    const ClickHandler = () => { window.scrollTo(10, 0); };

    return (
        <div className="item-contact_info">
            <div className="orbx-item--inner">
                <div className="orbx-item--top">
                    <h3 className="orbx-item--title">{t('contact.contactInfo')}</h3>
                    <ul className="orbx-contact-list list-unstyled pt-20">
                        <li><a href="tel:+995555275685" style={{color: '#fff'}}><i className="fas fa-phone"></i> +(995) 555 275 685</a></li>
                        <li><a href="tel:+995557253275" style={{color: '#fff'}}><i className="fas fa-phone"></i> +(995) 557 253 275</a></li>
                        <li><a href="mailto:info@orbitronix.ge" style={{color: '#fff'}}><i className="fas fa-envelope"></i> info@orbitronix.ge</a></li>
                    </ul>

                    <h3 className="orbx-title pt-50">{t('contact.socials')}</h3>
                    <ul className="social_icons_block list-unstyled ul_li pb-10">
                        <li><Link onClick={ClickHandler} to="https://www.facebook.com/orbitronixge" aria-label={t('contact.facebook')}><i className="fab fa-facebook-f"></i></Link></li>
                        <li><Link onClick={ClickHandler} to="https://www.linkedin.com/company/orbitronixge/" aria-label={t('contact.linkedin')}><i className="fab fa-linkedin-in"></i></Link></li>
                        <li><Link onClick={ClickHandler} to="https://www.instagram.com/orbitronixge" aria-label={t('contact.instagram')}><i className="fab fa-instagram"></i></Link></li>
                    </ul>
                </div>
                <div className="contact-info_widget">
                    <h3 className="orbx-title pb-20 pt-20">{t('contact.centralOffice')}</h3>
                    <span className="orbx-location"><i className="fas fa-building"></i> {t('contact.address')}</span>
                </div>
                <hr className="breack-line" />
                <div className="contact-info_widget">
                    <h3 className="orbx-title pb-20">{t('contact.serviceHours')}</h3>
                    <span className="orbx-location" style={{ lineHeight: '2.2' }} dangerouslySetInnerHTML={{ __html: t('contact.serviceHoursText') }} />
                </div>
                <hr className="breack-line" />
                <div className="mt-20">
                    <Link to={`/${lang}/contact`} className="orbx-btn w-100 text-center">
                        {t('common.contactUs')} <i className="fas fa-arrow-right"></i>
                    </Link>
                    <Link to={`/${lang}/audit`} className="orbx-btn-outline w-100 mt-3 text-center">
                        {t('common.freeAudit')} <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </div>
    );
};

const ServicePartnership = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    const features = [
        'Dedicated team extension',
        'Long-term strategic partnerships',
        'Shared product roadmaps',
        'Transparent communication channels',
        'Flexible engagement models',
        'Joint go-to-market strategies'
    ];

    const technologies = ['Agile', 'Scrum', 'Kanban', 'Jira', 'Slack', 'Notion'];

    return (
        <Fragment>
            <Seo
                title={`${t('services.partnership')} | OrbitroniX`}
                description={t('services.partnershipContent')}
                keywords="partnership, team extension, strategic, outsourcing, OrbitroniX"
                url={`/${lang}/services/partnership`}
            />
            <Layout>
                <ServiceNav currentSlug="partnership" lang={lang} />
                {/* Hero */}
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="page-title pt-150 pos-rel bg_img"
                >
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.3 }}
                                        className="page-title-box"
                                    >
                                        <motion.span
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.5 }}
                                            className="sub-title"
                                        >
                                            <img src={icon} alt="" /> {t('services.title')}
                                        </motion.span>
                                        <motion.h2
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.7 }}
                                            className="title"
                                        >
                                            🚀 {t('services.partnership')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* Content */}
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className="terms&conditions-section pb-85 cp-det-bg"
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="item-details-widget" style={{ padding: '50px' }}>
                                    <p className="text-white-50 mb-4" style={{ fontSize: '18px', lineHeight: '1.8' }}>
                                        {t('services.partnershipContent')}
                                    </p>

                                    <h3 className="text-white mb-30">{t('common.keyFeatures')}</h3>
                                    <div className="row mb-50">
                                        {features.map((feature, index) => (
                                            <div className="col-md-6 mb-3" key={index}>
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-check-circle text-primary me-2"></i>
                                                    <span className="text-white-50">{feature}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <h3 className="text-white mb-30">{t('common.technologies')}</h3>
                                    <div className="d-flex flex-wrap gap-2 mb-40">
                                        {technologies.map((tech, index) => (
                                            <span
                                                key={index}
                                                className="badge"
                                                style={{
                                                    background: 'rgba(108, 92, 231, 0.2)',
                                                    color: '#a29bfe',
                                                    border: '1px solid rgba(108, 92, 231, 0.4)',
                                                    padding: '8px 16px',
                                                    borderRadius: '20px',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {tech}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <ServiceSidebar lang={lang} />
                            </div>
                        </div>
                    </div>
                </motion.section>

                <section className="pb-85 cp-det-bg">
                    <div className="container">
                        <ServicePortfolio category="web" />
                    </div>
                </section>
            </Layout>
        </Fragment>
    );
};

export default ServicePartnership;
